const Phrases = () => {
    return <div>
        <h2>Phrases</h2>
    </div>;
}

export default Phrases;
